import { Component, Input, OnInit } from '@angular/core';
import { ConsentTypes } from '@credit-acceptance/shareable-utilities';
import { map, takeUntil, tap } from 'rxjs';

import { ConsentTextInfoRestService } from '../services/consent-test-info-rest.service';
import { Unsubscribe } from '../shared/classes/unsubscribe.class';
import { FinalSuccessEventsService } from '../shared/service/final-success-events.service';
import { accessToken, cacChubSSNId } from '../shared/state/local-cache';

@Component({
  selector: 'capq-product-terms',
  templateUrl: './product-terms.component.html',
  styleUrls: ['./product-terms.component.scss'],
  standalone: false,
})
export class ProductTermsComponent extends Unsubscribe implements OnInit {
  productTerms = '';
  showTermsSection = false;
  showWebsiteLink = false;

  constructor(
    private consentTextInfoRestService: ConsentTextInfoRestService,
    private finalSuccessEventsService: FinalSuccessEventsService
  ) {
    super();
  }
  ngOnInit(): void {
    this.finalSuccessEventsService.showWebSiteLink$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event) => {
        if (event === 'showDealerWebsite') {
          this.showWebsiteLink = true;
        }
      });

    this.consentTextInfoRestService
      .getConsentByType(ConsentTypes.PRODUCT_TERMS)
      .pipe(
        tap((resp) => {
          const accessTokenRef = resp.headers?.get('access-token');
          if (accessTokenRef) accessToken(accessTokenRef);
          const chubSSNid = resp.headers?.get('cac-chub-ssid');
          if (chubSSNid) cacChubSSNId(chubSSNid);
        }),
        map((resp) => resp.body?.getConsentByType),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((productTerms) => {
        if (productTerms) {
          this.productTerms = productTerms.consenttext;
        }
      });
  }

  toggleTermsSection() {
    this.showTermsSection = !this.showTermsSection;
  }
}
